import { Injectable } from '@angular/core';
import { HttpClientService } from '../httpClient/httpclient.service';
import { MessageService } from 'primeng/api';
import { Observable } from 'rxjs/Observable';
import { CalendarGroupItem, CalendarGroupItemExt } from '../../models/calendar-group-item.model';
import { HttpParams } from '@angular/common/http';
import { publishReplay, refCount } from 'rxjs/operators';

@Injectable()
export class CalendarGroupItemService {

  private baseUrl = HttpClientService.BASE_MS_COMMON + '/calendar-group-item';
  private cachedFields: Observable<any>;

  constructor (
    private h: HttpClientService,
    private messageService: MessageService
  ) { }

  getAll(): Observable<CalendarGroupItem[]> {
    return this.h.get(this.baseUrl + '/');
  }

  getAllByGroupId(calendarGroupId): Observable<CalendarGroupItemExt[]> {
    let params: HttpParams = new HttpParams();
    params = params.set('calendar_group_id', calendarGroupId);

    return this.h.get(this.baseUrl + '/', params.toString());
  }

  get(id): Observable<CalendarGroupItem> {
    return this.h.get(this.baseUrl + '/' + id);
  }

  delete (record) {
    return this.h.delete(this.baseUrl + '/' + record.id)
      .map(res => {
        this.messageService.add({severity: 'info', summary: 'Confirmed', detail: 'Calendar Group deleted'});
        return res;
      });
  }

  post (newData: CalendarGroupItem) {
    return this.h.post(this.baseUrl + '/', newData)
      .map(res => {
        newData.id = res.id;
        this.messageService.add({severity: 'info', summary: 'Success', detail: 'Operation success'});
        return res;
      });

  }

  put (data: CalendarGroupItem) {
    return this.h.put(this.baseUrl + '/', data)
      .map(res => {
        this.messageService.add({severity: 'info', summary: 'Success', detail: 'Operation success'});
        return res;
      });
  }

  getFields() {
    if (!this.cachedFields) {
      this.cachedFields = this.h.get('/koncentro-common/schema/CalendarGroupItemDto').pipe(
        publishReplay(1), // this tells Rx to cache the latest emitted
        refCount() // and this tells Rx to keep the Observable alive as long as there are any Subscribers
      )
    }
    return this.cachedFields;
  }

}



// WEBPACK FOOTER //
// ./src/app/services/calendar-group-item/calendar-group-item.service.ts